import * as React from 'react';

import { AppFormField, AppFormFieldOwnProps, AppFormFieldProps } from '../appFormField';

import { ColorPickerComponent, ColorPickerProps } from './color-picker.component';

type ColorPickerFieldComponentProps = AppFormFieldOwnProps & ColorPickerProps;

type FieldProps = AppFormFieldProps & ColorPickerProps;

export class ColorPickerFieldComponent extends AppFormField<ColorPickerFieldComponentProps> {
  protected renderInput(field: FieldProps): JSX.Element {
    const { input, preview, ...props } = field;

    return <ColorPickerComponent {...input} preview={preview} {...props} />;
  }
}
